import React from 'react';
import * as ReactDOM from 'react-dom';
import {applyPolyfills, defineCustomElements} from '@garpix/garpix-web-components/loader';
import {BrowserRouter as Router} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import { StoreContext } from 'storeon/react';
import App from './components/App';
import store from './store';
import './styles/index.scss';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <StoreContext.Provider value={store}>
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover/>
      <App/>
    </Router>
  </StoreContext.Provider>,
  document.getElementById('root'));

applyPolyfills().then(() => {
  defineCustomElements();
});


